import axios from 'axios'
import {asResponse, qs} from '../util'

export const CONTRACT_FOR_PUBLISHED_DOCS_SWR_KEY = ({environmentId, accountName, serviceName, versionName, environmentName}) => [
  '/bff/services/contract-for-published-docs',
  environmentId,
  accountName,
  serviceName,
  versionName,
  environmentName
]

export const getContractForPublishedDocs = async (url, environmentId, accountName, serviceName, versionName, environmentName) => {
  const query = {
    environmentId,
    accountName,
    serviceName,
    versionName,
    environmentName
  }
  const resp = await asResponse(axios.get(`${url}${qs(query)}`))
  return resp.data
}

export const updateContract = async (contract) => {
  const resp = await asResponse(axios.put(`/bff/contract/${contract.id}`, contract))
  return resp.data
}

export const getContract = async (contract, options = {}) => {
  const {
    augmentEnvironmentId = ''
  } = options
  const augmentQueryParam = augmentEnvironmentId ? `?augment=${contract.serviceId},${augmentEnvironmentId}` : ''
  const resp = await asResponse(axios.get(`/bff/contract/${contract.id}${augmentQueryParam}`))
  return resp.data
}

export const syncContract = async (serviceId, versionId) => {
  const resp = await asResponse(axios.post(`/bff/services/${serviceId}/versions/sync-with-contract`, {versionId}))
  return resp.data
}
